import {
  Directive,
  OnInit,
  TemplateRef,
  ViewContainerRef,
} from '@angular/core';
import { AuthorizationService } from '@core/services';
import { SessionState } from '@core/state/shared';

@Directive({
  selector: '[appUpdatePermission]',
})
export class UpdatePermissionDirective implements OnInit {
  constructor(
    private authorizationService: AuthorizationService,
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef,
    private sessionState: SessionState
  ) {}

  public ngOnInit() {
    if (
      (this.sessionState.isAdmin &&
        this.authorizationService.hasUpdatePermission()) ||
      !this.sessionState.isAdmin
    ) {
      this.viewContainer.createEmbeddedView(this.templateRef);
    }
  }
}
